document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const navigation = document.querySelector('[data-primary-nav]');

  if (navToggle && navigation) {
    navToggle.addEventListener('click', () => {
      const expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
      navigation.classList.toggle('is-open', !expanded);
    });

    navigation.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navToggle.setAttribute('aria-expanded', 'false');
        navigation.classList.remove('is-open');
      });
    });
  }

  const bookingForm = document.querySelector('#BookingRequestForm');
  if (!bookingForm) return;

  const serviceSelect = bookingForm.querySelector('[data-service-select]');
  const addOns = Array.from(bookingForm.querySelectorAll('[data-addon]'));
  const totalOutput = document.querySelector('[data-estimate-total]');
  const detailOutput = document.querySelector('[data-estimate-detail]');
  const estimateInput = bookingForm.querySelector('[data-estimate-input]');
  const summaryInput = bookingForm.querySelector('[data-summary-input]');

  const money = (amount) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(amount);

  const updateEstimate = () => {
    const selectedOption = serviceSelect.options[serviceSelect.selectedIndex];
    const servicePrice = Number(selectedOption?.dataset.price || 0);
    const selectedAddOns = addOns.filter((addOn) => addOn.checked);
    const addOnTotal = selectedAddOns.reduce((sum, addOn) => sum + Number(addOn.dataset.price || 0), 0);
    const total = servicePrice + addOnTotal;
    const serviceName = serviceSelect.value || 'No service selected';
    const addOnNames = selectedAddOns.map((addOn) => addOn.dataset.label);

    if (totalOutput) totalOutput.textContent = money(total);
    if (estimateInput) estimateInput.value = money(total);
    if (detailOutput) {
      detailOutput.textContent = serviceSelect.value
        ? `${serviceName}${addOnNames.length ? ` with ${addOnNames.join(', ')}` : ''}`
        : 'Select a service to see the estimate.';
    }
    if (summaryInput) {
      summaryInput.value = `Service: ${serviceName}. Add-ons: ${addOnNames.length ? addOnNames.join(', ') : 'None'}. Estimate: ${money(total)}. Payment: after service.`;
    }
  };

  serviceSelect.addEventListener('change', updateEstimate);
  addOns.forEach((addOn) => addOn.addEventListener('change', updateEstimate));

  document.querySelectorAll('[data-book-service]').forEach((button) => {
    button.addEventListener('click', () => {
      const service = button.dataset.bookService;
      const matchingOption = Array.from(serviceSelect.options).find((option) => option.value === service);
      if (matchingOption) {
        serviceSelect.value = service;
        updateEstimate();
      }
    });
  });

  const requestedService = new URLSearchParams(window.location.search).get('service');
  if (requestedService) {
    const matchingOption = Array.from(serviceSelect.options).find(
      (option) => option.value.toLowerCase() === requestedService.toLowerCase()
    );
    if (matchingOption) serviceSelect.value = matchingOption.value;
  }

  bookingForm.addEventListener('submit', updateEstimate);
  updateEstimate();
});
